import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import heroImage from '../assets/hero-enhanced.png';

export default function Hero() {
  return (
    <section id="home" className="pt-28 pb-16 md:pt-36 md:pb-24 bg-surface overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20">
          
          {/* Text Content */}
          <div className="w-full md:w-1/2 space-y-8">
            
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand/10 text-brand-dark text-xs font-semibold uppercase tracking-wider">
              <span className="w-2 h-2 rounded-full bg-brand"></span>
              Santa Rosa's Premier Garment Care
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-[1.1]">
              Premium Dry Cleaning & <span className="text-brand">Garment Care</span>
            </h1>
            
            <p className="text-lg text-gray-600 leading-relaxed max-w-lg">
              Expert cleaning, pressing, alterations, and convenient pickup & delivery. 
              Experience the difference of professional care for your wardrobe.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="#services" 
                className="px-8 py-4 bg-brand text-white rounded-full font-semibold hover:bg-brand-dark transition-all shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
              >
                View Services
                <ArrowRight size={18} />
              </a>
              <a 
                href="#pickup" 
                className="px-8 py-4 bg-white text-gray-800 border border-gray-200 rounded-full font-semibold hover:bg-gray-50 transition-all flex items-center justify-center"
              >
                Schedule Pickup
              </a>
            </div>

            <div className="flex items-center gap-6 text-sm text-gray-500 pt-4 border-t border-gray-100 mt-4">
              <div className="flex items-center gap-2">
                <CheckCircle size={16} className="text-brand" />
                <span>Fast Turnaround</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle size={16} className="text-brand" />
                <span>Professional Care</span>
              </div>
              <div className="flex items-center gap-2">
                <CheckCircle size={16} className="text-brand" />
                <span>2 Locations</span>
              </div>
            </div>
          </div>

          {/* Image Content */}
          <div className="w-full md:w-1/2 relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3] group">
              <div className="absolute inset-0 bg-brand/10 group-hover:bg-transparent transition-colors duration-500 z-10"></div>
              <img 
                src={heroImage} 
                alt="Premium Dry Cleaning Interior" 
                className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-brand/10 rounded-full blur-2xl -z-10"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-brand/10 rounded-full blur-2xl -z-10"></div>
          </div>
          
        </div>
      </div>
    </section>
  );
}
